import React from 'react';
import { StyleSheet, View } from './components/base_components';

import ProgressSpinner from './components/progress_spinner';

import VolumeMediaScreen from './volume_media_screen';
import VolumeFuseScreen from './volume_fuse_screen';

import VolumeStore from './stores/volume_store';

const styles = StyleSheet.create({
  volumeScreen: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
});

type Props = {};
type State = {
  volume_id: number;
  volume: any;
};

export default class VolumeScreen extends React.PureComponent<Props, State> {
  state = {
    volume_id: this._getVolumeId(),
    volume: null,
  };
  componentDidMount() {
    VolumeStore.addChangeListener(this._onVolumeUpdate);
    VolumeStore.fetch();
    this._onVolumeUpdate();
  }
  componentWillUnmount() {
    VolumeStore.removeChangeListener(this._onVolumeUpdate);
  }
  componentWillReceiveProps(newProps: any) {
    const volume_id = this._getVolumeId(newProps);
    if (volume_id !== this.state.volume_id) {
      this.setState({ volume_id, volume: null });
    }
  }
  _onVolumeUpdate = () => {
    const volume_id = this._getVolumeId();
    const volume = VolumeStore.getVolume(volume_id);
    this.setState({ volume });
  };
  _getVolumeId(newProps?: any): number {
    const props = newProps || this.props;
    const volume_id = parseInt(props.match.params.volume_id) || 0;
    return volume_id;
  }

  render() {
    const { volume_id, volume } = this.state;
    console.log('render:', volume_id, volume);

    let content = null;
    if (volume) {
      if (volume.is_media_volume) {
        content = <VolumeMediaScreen {...this.props} />;
      } else {
        content = <VolumeFuseScreen {...this.props} />;
      }
    } else {
      content = <ProgressSpinner />;
    }

    return <View style={styles.volumeScreen}>{content}</View>;
  }
}
